// extracted by mini-css-extract-plugin
module.exports = {"FullLayout":"full-layout_FullLayout__sMiZ0","Container":"full-layout_Container__Lqx0T","Shape":"full-layout_Shape__xHHEL","Footer":"full-layout_Footer__yLHfg"};